// Firmware Updates translations for React Admin resource
export const firmwareUpdatesResource = {
  name: '韌體更新 |||| 韌體更新',
  fields: {
    id: 'ID',
    firmware_id: '韌體',
    firmware_version: '韌體版本',
    firmware_description: '韌體說明',
    site: '站點',
    vendor: '廠商',
    model: '型號',
    version: '版本',
    target_type: '目標類型',
    target_chargers: '目標充電樁',
    target_sites: '目標站點',
    total_chargers: '充電樁總數',
    charger_ids: '目標充電樁',
    scheduled_at: '排程時間',
    download_url: '下載連結',
    retrieve_date: '下載日期',
    install_date: '安裝日期',
    status: '狀態',
    progress: '進度',
    created_at: '建立時間',
    updated_at: '更新時間',
  },
};

// Custom firmware updates translations for components
export const firmwareUpdates = {
  subtitle: '管理充電樁韌體更新任務',
  validation: {
    firmware_required: '韌體選擇為必填欄位',
    chargers_required: '至少必須選擇一個充電樁',
    scheduled_at_future: '排程時間必須在未來',
  },
  helpers: {
    firmware: '選擇要部署的韌體版本',
    site: '選擇充電樁所在的站點',
    vendor: '選擇充電樁廠商',
    model: '選擇充電樁型號',
    target_type: '選擇目標充電樁的方式',
    target_chargers: '點擊開啟下拉選單，使用搜尋和勾選框選擇充電樁',
    target_sites: '選擇站點 - 這些站點的所有充電樁將被更新',
    chargers: '選擇此更新的目標充電樁',
    scheduled_at: '排程更新時間（留空表示立即執行）',
    retrieve_date: '充電樁應該下載韌體的時間',
    install_date: '充電樁應該安裝並重新啟動的時間（選填）',
    chargers_selected: '個充電樁已選擇',
    no_chargers_found: '找不到符合搜尋條件的充電樁',
    no_chargers: '沒有可用的充電樁',
    select_site_first: '請先選擇站點以繼續。',
    select_vendor_model_first: '請先選擇廠商和型號以查看可用的韌體。',
    no_chargers_vendor_model: '此站點找不到具有廠商資訊的充電樁。請確保充電樁已從 OCPP 填入廠商和型號資料。',
    no_models_available: '此廠商沒有可用的型號。',
    no_chargers_combination: '找不到此站點、廠商和型號組合的充電樁。',
    no_firmware_available: '{vendor} {model} 沒有可用的韌體。請先為此廠商/型號組合上傳韌體。',
    firmware_count: '{vendor} {model} 有 {count} 個可用',
  },
  sections: {
    firmware_selection: '韌體選擇',
    target_selection: '目標充電樁',
    schedule: '更新排程',
    status: '更新狀態',
  },
  actions: {
    create_update: '建立更新任務',
    cancel: '取消更新',
    query_status: '查詢狀態',
    retry: '重試失敗項目',
    select_all: '全選',
    deselect_all: '取消全選',
    search_chargers: '搜尋充電樁...',
  },
  target_types: {
    charger: '個別充電樁',
    site: '站點所有充電樁',
    bulk: '批量更新（所有相容）',
  },
  statuses: {
    pending: '待處理',
    sent: '已發送',
    in_progress: '進行中',
    completed: '已完成',
    downloading: '下載中',
    downloaded: '已下載',
    installing: '安裝中',
    installed: '已安裝',
    installation_failed: '安裝失敗',
    installationfailed: '安裝失敗',
    download_failed: '下載失敗',
    downloadfailed: '下載失敗',
    cancelled: '已取消',
  },
  warnings: {
    ocpp_command: '這將觸發 OCPP UpdateFirmware 命令到所有選定的充電樁。請確保韌體與目標充電樁相容。',
    immediate_update: '韌體更新將在建立後立即開始。請確保所選充電樁目前沒有用戶正在充電。',
  },
  create: {
    title: '建立韌體更新',
    subtitle: '為充電樁排程韌體更新',
  },
  show: {
    title: '韌體更新詳情',
    subtitle: '檢視更新狀態和進度',
  },
  list: {
    title: '韌體更新',
    filters: {
      search: '搜尋版本或充電樁',
      status: '狀態',
    },
    empty: {
      title: '找不到韌體更新',
      subtitle: '建立您的第一個韌體更新任務以開始更新充電樁。',
    },
  },
  notifications: {
    created: '韌體更新任務建立成功',
    cancelled: '韌體更新取消成功',
    status_queried: '狀態查詢已發送至充電樁',
    failed_load_sites: '載入站點失敗',
    failed_load_vendors_models: '載入充電樁廠商和型號失敗',
    failed_load_chargers: '載入充電樁失敗',
    error: {
      create: '建立韌體更新失敗',
      cancel: '取消韌體更新失敗',
      query_status: '查詢狀態失敗',
      no_chargers: '未選擇充電樁',
    },
  },
  modals: {
    version_warning: {
      title: '韌體版本警告',
      message: '以下充電樁已經擁有等於或更新的韌體版本。繼續可能導致降級或重新安裝：',
      current_version: '目前版本',
      target_version: '目標版本',
      warning_text: '警告：降級或重新安裝韌體可能導致意外行為或暫時中斷充電服務。您確定要繼續嗎？',
      cancel: '取消',
      proceed: '仍然繼續',
    },
    blocker: {
      title: '無法啟動韌體更新',
      message: '只有在所有充電樁閒置（沒有進行中的充電時段）時才能進行韌體更新',
      info: '請等待所有充電樁變為閒置（沒有進行中的充電時段）再嘗試韌體更新。',
      ok: '確定',
    },
  },
  toolbar: {
    save: '儲存',
  },
  charger_status: {
    title: '充電樁更新狀態',
    charger_id: '充電樁 ID',
    status: '狀態',
    last_updated: '最後更新',
    error_message: '錯誤訊息',
  },
};
